import { render } from "./CategoryButton.vue?vue&type=template&id=2b19fda0&scoped=true"
import script from "./CategoryButton.vue?vue&type=script&lang=js"
export * from "./CategoryButton.vue?vue&type=script&lang=js"

import "./CategoryButton.vue?vue&type=style&index=0&id=2b19fda0&lang=scss&scoped=true"

import exportComponent from "/Users/stepanmaksimov/Documents/Claude/Projects/A.sk/answerio-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b19fda0"]])

export default __exports__